export const MessageEvents = {
  CLIPBOARD: "clipboard",
  IMAGE_PICKER_CAMERA: "image_picker_camera",
  IMAGE_PICKER_LIBRARY: "image_picker_library",
  LOG_ERROR: "log_error",
  LOG_INFO: "log_info",
  OPEN_URL: "open_url",
  NOTIFICATION_TOKEN: "notification_token",
  NOTIFICATION_MESSAGE: "notification_message",
};

/* export interface ImagePickerResult {
  assets?: {
    assetId?: string;
    base64?: string;
    duration?: string;
    exif?: Record<string, any>;
    height: number;
    rotation?: any;
    type?: "image" | "video";
    uri: string;
    width: number;
  }[];
  canceled: boolean;
} */

const postMessage = (data) => {
  globalThis.ReactNativeWebView?.postMessage?.(JSON.stringify(data));
};

const parseData = (data) => {
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};

export const postMessageSync = (messageEvent, data) => {
  // Request native auth
  postMessage({ event: messageEvent, data });
};

export const postMessageAsync = (messageEvent, data, timeout = 60000) => {
  if (!messageEvent) {
    return Promise.reject(new Error("messageEvent is required"));
  }

  return new Promise((resolve, reject) => {
    const timeoutId = { current: null };

    const cleanup = () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }

      if (globalThis.nativeOS && globalThis.nativeOS === "ios") {
        globalThis.removeEventListener("message", handleResponse);
      } else {
        document.removeEventListener("message", handleResponse);
      }
    };

    const handleResponse = (event) => {
      if (event?.data) {
        const json = parseData(event.data);

        if (json?.event === messageEvent) {
          cleanup();

          if (json.type === "error") {
            reject(
              new Error(json.message || `Algo deu errado com ${messageEvent}`),
            );
          } else {
            resolve(json.data);
          }
        }
      }
    };

    timeoutId.current = setTimeout(() => {
      cleanup();
      reject(
        new Error(`Timeout de ${timeout}ms atingido para ${messageEvent}`),
      );
    }, timeout);

    if (globalThis.nativeOS && globalThis.nativeOS === "ios") {
      globalThis.addEventListener("message", handleResponse);
    } else {
      document.addEventListener("message", handleResponse);
    }

    // Request native auth
    postMessage({ event: messageEvent, data });
  });
};

const NativeEvents = new Map();

export const addNativeEventListener = (messageEvent, callback) => {
  // Validação de entrada
  if (!messageEvent || typeof callback !== "function") {
    throw new Error(
      "messageEvent and callback are required, callback must be a function",
    );
  }

  // Remove listener existente se houver
  if (NativeEvents.has(messageEvent)) {
    const existingRemover = NativeEvents.get(messageEvent).remove;
    existingRemover?.();
  }

  const handleResponse = (event) => {
    if (event?.data) {
      const json = parseData(event.data);

      if (json?.event === messageEvent) {
        const currentCallback = NativeEvents.get(messageEvent)?.callback;
        currentCallback?.(json.data);
      }
    }
  };

  const removeEvent = () => {
    const existingHandler = NativeEvents.get(messageEvent)?.handler;
    if (!existingHandler) {
      return;
    }
    if (globalThis.nativeOS && globalThis.nativeOS === "ios") {
      globalThis.removeEventListener("message", existingHandler);
    } else {
      document.removeEventListener("message", existingHandler);
    }
    NativeEvents.delete(messageEvent);
  };

  // Armazena callback e função de remoção
  NativeEvents.set(messageEvent, {
    callback,
    remove: removeEvent,
    handler: handleResponse,
  });

  if (globalThis.nativeOS && globalThis.nativeOS === "ios") {
    globalThis.addEventListener("message", handleResponse);
  } else {
    document.addEventListener("message", handleResponse);
  }

  return {
    remove: removeEvent,
  };
};

export const removeNativeEventListener = (messageEvent) => {
  if (NativeEvents.has(messageEvent)) {
    const existingRemover = NativeEvents.get(messageEvent).remove;
    existingRemover?.();
    NativeEvents.delete(messageEvent);
  }
};

export const removeAllNativeEventListeners = () => {
  NativeEvents.forEach((event) => {
    event.remove?.();
  });
  NativeEvents.clear();
};
